import { IInstallServices, IServices, IUpdateService } from '../_types/IUpdates';

const getServices = async (): Promise<IServices> => {
    return new Promise<IServices>(resolve => setTimeout(() => resolve({
        services: [
            {name: 'test1', version: '1.0', download: 'today'},
            {name: 'test2', version: '1.0', download: 'today'},
        ]
    }), 1000));
};

const updateServices = async (services: IInstallServices): Promise<void> => {
    return console.log(services);
};

export const updateService: IUpdateService = {
    getServices,
    updateServices,
};